import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { AppContext } from '@prisjakt/ui-app-context';
import { ScrollElement } from '@prisjakt/ui-scroll';
import ArrowIconUp from 'mdi-react/ChevronUpIcon';
import ArrowIconDown from 'mdi-react/ChevronDownIcon';
import CrossIcon from 'mdi-react/CloseIcon';
import ListItem from '@prisjakt/ui-list-item';
import PanelHeader from '@prisjakt/ui-panel-header';

import FilterPanel from './components/panel';
import ApplyFilterButton from './components/apply-filter-button';
import SelectedFilters from './components/selected-filters';
import FilterToggle from '../filter-toggle';

import filterActions from '../../actions/filter';

import * as S from './styles';

class Filter extends React.PureComponent {
  constructor(props) {
    super(props);
    this.closeMobileFilter = this.closeMobileFilter.bind(this);
  }

  componentWillUnmount() {
    this.props.toggleMobile(false);
    this.props.propertySearch('');
  }

  closeMobileFilter() {
    window.scroll(0, 0);
    this.props.toggleMobile(false);
  }

  render() {
    const { expandedCategories, mobileOpen } = this.props.filter;

    const hasFiltered = Object.keys(this.props.filter.query).length > 0;

    const { t } = this.context;

    const {
      inputValue,
      filteredCore,
      filteredSections,
      filteredValues,
      disabledExpansions,
    } = this.props.search;

    const isBrandedCategory = Boolean(this.props.brand);
    const isSearching = inputValue.length > 1;

    return (
      <S.FilterWrapper>
        <ScrollElement name="Filter">
          <S.HeaderWrapper mobileOpen={mobileOpen}>
            <S.Header>
              <PanelHeader divider="none" title={t('filter', 'filter.title')}>
                {this.props.showFilterToggle && (
                  <FilterToggle
                    toggleHorizontalFilter={this.props.toggleFilter}
                    expanded={this.props.expanded}
                  />
                )}
              </PanelHeader>
            </S.Header>

            <SelectedFilters categoryId={this.props.categoryId} />

            <S.CloseButton
              type="button"
              onClick={this.closeMobileFilter}
              mobileOpen={mobileOpen}
            >
              <CrossIcon />
            </S.CloseButton>
          </S.HeaderWrapper>

          {this.props.quickFilters.length > 0 && (
            <div>
              {this.props.quickFilters.map(c => (
                <ListItem
                  key={c.name}
                  name={c.name}
                  link={c.pathName}
                  showArrow
                />
              ))}
            </div>
          )}

          <div>
            <S.Input
              placeholder={t('filter', 'properties.search-placeholder')}
              value={inputValue}
              onChange={event => {
                this.props.propertySearch(event.target.value);
              }}
            />
          </div>

          <S.Filter>
            <div>
              {filteredCore.map(coreFilter => (
                <FilterPanel
                  key={coreFilter.id}
                  canCompare={this.props.canCompare}
                  isBrandFilteredCategory={isBrandedCategory}
                  displayFilter={coreFilter}
                  filteredValues={filteredValues}
                />
              ))}
            </div>

            {filteredSections.map(section => {
              const showSection = isSearching
                ? disabledExpansions.indexOf(section.name) < 0 // Defaults to expanded
                : expandedCategories.indexOf(section.name) >= 0; // Defaults to collapsed

              // Remove empty sections
              if (
                section.children.filter(
                  subFilter =>
                    (subFilter.item_type === 'category' &&
                      subFilter.children) ||
                    (filteredValues &&
                      filteredValues[subFilter.id] &&
                      filteredValues[subFilter.id].max_matching_products)
                ).length === 0
              ) {
                return null;
              }

              return (
                <React.Fragment key={section.name}>
                  <S.ButtonWrapper>
                    <S.ExpansionButton
                      type="button"
                      onClick={() =>
                        isSearching
                          ? this.props.propertySearchToggleExpansion(
                              section.name
                            )
                          : this.props.expandSection(section.name)
                      }
                    >
                      <div>{section.name}</div>
                    </S.ExpansionButton>
                    <S.ArrowButton
                      type="button"
                      onClick={() =>
                        isSearching
                          ? this.props.propertySearchToggleExpansion(
                              section.name
                            )
                          : this.props.expandSection(section.name)
                      }
                    >
                      {showSection ? <ArrowIconUp /> : <ArrowIconDown />}
                    </S.ArrowButton>
                  </S.ButtonWrapper>
                  {showSection && (
                    <FilterPanel
                      key={section.name}
                      isBrandFilteredCategory={isBrandedCategory}
                      displayFilter={section}
                      filteredValues={filteredValues}
                      hideName
                    />
                  )}
                </React.Fragment>
              );
            })}
          </S.Filter>
        </ScrollElement>
        <ApplyFilterButton
          productCount={this.props.productCount}
          hasFiltered={hasFiltered}
          onClick={this.closeMobileFilter}
        />
      </S.FilterWrapper>
    );
  }
}

const { object, func, number, string, array, bool } = PropTypes;

Filter.propTypes = {
  categoryId: string.isRequired,
  category: object.isRequired,
  filter: object.isRequired,
  search: object.isRequired,
  brand: object,
  expandSection: func.isRequired,
  propertySearch: func.isRequired,
  propertySearchToggleExpansion: func.isRequired,
  toggleMobile: func.isRequired,
  filterQuery: func.isRequired,
  productCount: number,
  className: string,
  quickFilters: array.isRequired,
  canCompare: bool,
  showFilterToggle: bool,
  toggleFilter: func.isRequired,
  expanded: bool,
};

Filter.defaultProps = {
  productCount: 0,
  className: '',
  brand: null,
  canCompare: true,
  showFilterToggle: false,
  expanded: false,
};

export default connect(
  state => state.areas.category,
  filterActions
)(withRouter(Filter));

Filter.contextType = AppContext;
